export const environment = {
  production: true,
  api_origin: '#{ApiURL}#api', // 'https://talydt3mmk.execute-api.ca-central-1.amazonaws.com/Prod/api',
  client_origin: '#{clientOrigin}#', // 'https://live.livelanguageexpressapp.com/#/'
  gmap_api_key: '#{GMapApiKey}#',
  weather_api_key: '#{WeatherApiKey}#',
  eventItem_pageSize: '#{EventItemPageSize}#',
  gtag: '#{GTag}#'
};
